"use strict";
function _type_of(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "buttonClasses", {
    enumerable: true,
    get: function get() {
        return _buttonClasses.default;
    }
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function get() {
        return _Button.default;
    }
});
Object.defineProperty(exports, "getButtonSlots", {
    enumerable: true,
    get: function get() {
        return _Button.getButtonSlots;
    }
});
var _Button = _interopRequireWildcard(require("./Button"));
var _buttonClasses = _interopRequireDefault(require("./buttonClasses"));
function _interopRequireWildcard(e, t) {
    if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap();
    return (_interopRequireWildcard = function _interopRequireWildcard(e, t) {
        if (!t && e && e.__esModule) return e;
        var o, i, f = {
            __proto__: null,
            default: e
        };
        if (null === e || "object" != (typeof e === "undefined" ? "undefined" : _type_of(e)) && "function" != typeof e) return f;
        if (o = t ? n : r) {
            if (o.has(e)) return o.get(e);
            o.set(e, f);
        }
        for(var _$t in e)"default" !== _$t && ({}).hasOwnProperty.call(e, _$t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _$t)) && (i.get || i.set) ? o(f, _$t, i) : f[_$t] = e[_$t]);
        return f;
    })(e, t);
} //# sourceMappingURL=index.js.map
